import { Component } from '@angular/core';
import { AlertController, ModalController } from 'ionic-angular';

import { SupplementEditPage } from './supplement-edit';
import { ConfigurationProvider, SupplementProvider } from '../../providers/providers';
import { SupplementModel } from '../../models/models';

@Component({
  selector: 'page-supplement',
  templateUrl: 'supplement.html',
})
export class SupplementPage {
  itemList: any = [];
  page: string = 'supplements';

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private suppProvider: SupplementProvider,
    private modalCtrl: ModalController) {
  }

  doAdd(item: SupplementModel = new SupplementModel()) {
    let modal = this.modalCtrl.create(SupplementEditPage, { 
      item: item
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved && data.name) {
        this.config.showToast('"' + data.name + '" saved!');
        this.loadView();
      }
    });
  }

  doRemove(item: SupplementModel) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            this.config.showLoading('Removing...');
            this.suppProvider.Remove(item).then((items) => {
              this.itemList = items;
              this.config.showToast(item.Name + ' removed!');
              this.config.dismissLoading();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  ionViewDidLoad() {
    this.loadView();
  }

  loadView() {
    const processList = () => {
      if (this.itemList) {
        this.itemList = this.suppProvider.Sort();
        for (let item of this.itemList) {
          item.icon = 'arrow-dropdown';
        }
      };
    }

    this.itemList = this.suppProvider.List();

    if (this.itemList.length > 0) {
      processList();
    }
    else {
      this.config.showLoading();
      this.suppProvider.Load().then(() => {
        processList();
        this.config.dismissLoading();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/supplement.ts